import React from 'react';
import './servicecards.scss';

const ServiceCards = ({ title, children }) => {
    return (
        <div className="service-cards">
            <h2>{title}</h2>
            <div className="service-cards-content">
                {children}
            </div>
        </div>
    );
};

export default ServiceCards;